export const T = {
  en: {
    nav: {
      dashboard:"Dashboard", profile:"Profile", stats:"Statistics",
      maps:"Maps", admin:"Admin", home:"Home", search:"Search",
    },
    landing: {
      hero1:"Track your", hero2:"osu! progress",
      heroSub:"Stats, map recommendations and skill breakdown based on your actual top plays. Login with osu! OAuth, no account needed.",
      loginBtn:"Login with osu!",
      featTitle:"What osu!nya actually does",
      feat1t:"Map Recommendations", feat1d:"Pulls your top 100 plays, finds your weak spots by star rating and mod type, then shows maps in that range from the ranked catalog.",
      feat2t:"Performance Analytics", feat2d:"PP progress over time, rank history chart, accuracy trend and per-session play count. All pulled directly from osu! API.",
      feat3t:"Skill Breakdown", feat3d:"Splits your top plays into 6 categories: Aim, Speed, Accuracy, Stamina, Reading, Tech. Shows which skills carry you and which hold you back.",
      cta:"Get Started Free",
      footer:"Built for the community · Not affiliated with osu! or ppy Pty Ltd",
    },
    dash: {
      welcome:"Welcome back,", ppProgress:"PP Progress", skillRadar:"Skill Radar",
      grades:"Grades", recentPlays:"Recent Plays", mapsForYou:"Maps For You",
      basedOn:"Based on your top play —", viewAll:"View full catalog →",
      addQueue:"+ Add to Queue", added:"✓ Added",
      filters:["All","Farm","Challenge","Hard"],
    },
    profile: {
      edit:"Edit Profile", save:"Save Changes", cancel:"Cancel",
      stats:"Account Statistics", topPlay:"Top Performance", level:"Level Progress",
      grades:"Grade Distribution", since:"Member since",
    },
    stats: {
      title:"Statistics Overview", last7:"Last 7 Days", improving:"↑ Improving",
      rankHistory:"Global Rank History", playsDay:"Plays per Day", ppDay:"PP Gained per Day",
      skillBreak:"Skill Breakdown",
    },
    maps: {
      title:"Map Catalog", subtitle:"Tailored for your top play of",
      search:"Search maps, artists, mappers…", sort:"Sort", grid:"Grid", list:"List",
      showing:"Showing", maps:"maps", addQueue:"+ Add", added:"✓",
    },
    admin: {
      title:"Admin Panel", subtitle:"Manage users, maps and system settings",
      adminOnly:"Admin Only", users:"Users", settings:"Settings", logs:"Logs",
      save:"Save Settings", clearCache:"Clear Cache",
    },
    common: { online:"Online", logout:"Logout", language:"Language", theme:"Theme", customize:"Customize" },
  },
  ru: {
    nav: {
      dashboard:"Дашборд", profile:"Профиль", stats:"Статистика",
      maps:"Карты", admin:"Панель", home:"Главная", search:"Поиск",
    },
    landing: {
      hero1:"Следи за своим", hero2:"osu! прогрессом",
      heroSub:"Статистика, рекомендации карт и разбивка навыков на основе твоих реальных топ игр. Вход через osu! OAuth, без регистрации.",
      loginBtn:"Войти через osu!",
      featTitle:"Что osu!nya реально умеет",
      feat1t:"Рекомендации карт", feat1d:"Берёт твои топ 100 игр, находит слабые места по звёздам и модам, показывает карты из этого диапазона из ранкед каталога.",
      feat2t:"Аналитика", feat2d:"PP за всё время, история рейтинга, тренд точности и количество игр по сессиям. Всё из osu! API.",
      feat3t:"Разбивка навыков", feat3d:"Делит топ игры на 6 категорий: Прицел, Скорость, Точность, Выносливость, Чтение, Техника. Показывает что тянет вверх а что тормозит.",
      cta:"Начать бесплатно",
      footer:"Создано для сообщества · Не аффилировано с osu! и ppy Pty Ltd",
    },
    dash: {
      welcome:"С возвращением,", ppProgress:"PP Прогресс", skillRadar:"Радар навыков",
      grades:"Грейды", recentPlays:"Последние игры", mapsForYou:"Карты для тебя",
      basedOn:"По твоему лучшему результату —", viewAll:"Полный каталог →",
      addQueue:"+ В очередь", added:"✓ Добавлено",
      filters:["Все","Фарм","Испытание","Хард"],
    },
    profile: {
      edit:"Редактировать", save:"Сохранить", cancel:"Отмена",
      stats:"Статистика аккаунта", topPlay:"Лучший результат", level:"Уровень",
      grades:"Распределение грейдов", since:"Игрок с",
    },
    stats: {
      title:"Обзор статистики", last7:"Последние 7 дней", improving:"↑ Улучшается",
      rankHistory:"История глобального рейтинга", playsDay:"Игр в день", ppDay:"PP в день",
      skillBreak:"Детализация навыков",
    },
    maps: {
      title:"Каталог карт", subtitle:"По твоему лучшему результату",
      search:"Поиск карт, исполнителей, мапперов…", sort:"Сорт.", grid:"Сетка", list:"Список",
      showing:"Показано", maps:"карт", addQueue:"+ Добавить", added:"✓",
    },
    admin: {
      title:"Панель администратора", subtitle:"Управление пользователями, картами и настройками",
      adminOnly:"Только для админов", users:"Пользователи", settings:"Настройки", logs:"Логи",
      save:"Сохранить", clearCache:"Очистить кеш",
    },
    common: { online:"Онлайн", logout:"Выйти", language:"Язык", theme:"Тема", customize:"Настроить" },
  },
};